import {useWindowSizeReducer} from '@/utils/hooks/useWindowSize'

export default function useNumberOfItemsPerRow() {
  return useWindowSizeReducer(width => {
    if (width <= 424) return 1
    if (width <= 767) return 2
    if (width <= 1023) return 3
    return 5
  })
}
